import React from 'react'
import styled from '@emotion/styled'
import Select from 'react-select'

import UsersService from 'Services/users'

const SelectOwner = styled(Select)`
  width: 100%;
`

// value is -1 because null is for Unassigned
export const allOptionOwner = { value: -1, label: 'All' }
export const ownerOptions = async officeIds => {
  const users = await UsersService.getByOffice({
    officeIds
  })

  const options = users.map(user => {
    return {
      value: user.id,
      label: user.initials ? user.initials : user.firstName
    }
  })

  // add unassigned option
  options.unshift({ value: null, label: 'Unassigned' })

  return options
}

export default React.memo(({ includeAll, ...props }) => {
  const options = [...props.options]
  if (includeAll) {
    options.unshift(allOptionOwner)
  }

  return <SelectOwner {...props} options={options} />
})
